export default {
    filters: {
        title: "Filtres",
        removeFilter: "Supprimer le filtre",
        filterIntensity: "Intensité du filtre",
        duotone: {
            title: "Bichromie",
            desert: "Désert",
            peach: "Pêche",
            clash: "Conflit",
            plum: "Prune",
            breezy: "Léger",
            deepBlue: "Bleu profond",
            frog: "Grenouille",
            sunset: "Coucher de soleil",
        },
        blackAndWhite: {
            title: "N & B",
            ad: "1920 après Jésus-Christ",
            greyed: "Huilé",
            dusty: "Poussiéreux",
            litho: " Lithographie",
            sepia: "Sépia",
            weathered: "Vieilli",
            hardStuff: "Des choses difficiles",
        },
        vintage: {
            title: "Rétro",
            polaroid: "Polaroid",
            sunny: "Années ensoleillées 70",
            oldTimer: "Vieux-timer",
            inferno: "Enfer",
            snappy: "Vif",
        },
        smooth: {
            title: "Lisse",
            chestnut: "Châtaigne",
            softy: "Moumou",
            pebble: "Caillou",
            moss: "Mousse",
            lemon: "Citron",
            greenGap: "Écart vert",
        },
        cold: {
            title: "Froid",
            colla: "Colle",
            solanus: "Solanus",
            kalmen: "Kalmen",
            jorah: "Joran",
            levante: "Levante",
            zephyr: "Zéphyr",
        },
        warm: {
            title: "Chaud",
            golden: "Doré",
            lowFire: "Feu doux",
            sunrise: "Levé du soleil",
            flatBack: "Dos plat",
            pumpkin: "Citrouille",
        },
    },
};
